import { useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[linear-gradient(140deg,#F7FAFC,#E2F2FB)] p-4">
      <form onSubmit={submit} className="w-full max-w-sm rounded-3xl bg-white border border-nanina-line p-6 sm:p-8 shadow-[0_20px_60px_rgba(35,75,67,0.1)]" data-testid="admin-login-form">
        <img src="/logo-nanina.png" alt="Logo Nanina Care" className="h-14 w-14" />
        <h1 className="mt-3 text-2xl font-extrabold tracking-tight text-nanina-green">Login Admin</h1>
        <p className="text-xs text-nanina-muted">Khusus tim Nanina Care.</p>
        <label className="mt-5 block text-xs font-semibold text-nanina-green">Email
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" className="mt-1.5 w-full rounded-xl border border-[#DCEAE6] px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-nanina-sky/50" data-testid="admin-login-email-input" />
        </label>
        <label className="mt-3 block text-xs font-semibold text-nanina-green">Kata sandi
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" className="mt-1.5 w-full rounded-xl border border-[#DCEAE6] px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-nanina-sky/50" data-testid="admin-login-password-input" />
        </label>
        <Link to="/admin/forgot-password" className="mt-2 inline-block text-xs font-semibold text-nanina-green hover:underline" data-testid="admin-forgot-password-link">Lupa Kata Sandi?</Link>
        {error && <p className="mt-3 text-xs text-red-600" role="alert" data-testid="admin-login-error">{error}</p>}
        <button disabled={busy} className="mt-5 w-full inline-flex justify-center items-center gap-2 rounded-full bg-nanina-green text-white text-sm font-semibold py-3 disabled:opacity-60" data-testid="admin-login-submit-button">
          <Lock className="h-4 w-4" /> {busy ? "Memproses..." : "Masuk"}
        </button>
        <Link to="/" className="mt-4 block text-center text-xs text-nanina-muted hover:text-nanina-green" data-testid="admin-login-back-link">Kembali ke website</Link>
      </form>
    </div>
  );
}
